<ion-header>
  <ion-toolbar #toolbar>
    <ion-buttons slot="start">
      <ion-button appClick (clicked)="onSpeichern()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title><span id="page-title-span">{{ title }}</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="auftrag" class="section-content" #content>

  <div class="section">
    <app-auftragsposition-wiegen [auftrag]="auftrag"
                                 [auftragsposition]="auftragsposition"
                                 [auftragdetails]="auftragdetails"
                                 [isPopup]="true"
                                 (changed)="onWiegungChanged()"></app-auftragsposition-wiegen>
  </div>

  <div class="section buttons-section">
    <ion-button appClick (clicked)="onSpeichern()" class="button-md button-border" expand="full" color="light">OK</ion-button>
  </div>
</ion-content>